import { createFileRoute } from "@tanstack/react-router";

import { CreateTeamPage } from "@/features/teams/CreateTeamPage";
import { usePageTitle } from "@/hooks/usePageTitle";

export const Route = createFileRoute("/_auth/_app-shell/teams/create")({
  component: RouteComponent,
});

function RouteComponent() {
  usePageTitle("Create Team");

  return <CreateTeamPage />;
}
